// src/data/legends.ts
// Registro de Lendas da Pesca para reconhecimento automático e tratamento VIP

export interface FishingLegend {
  id: string;
  type: 'legend' | 'pro' | 'influencer';
  status: 'verified' | 'pending' | 'unclaimed';
  
  // Identificação
  fullName: string;
  nicknames: string[];
  emailPatterns: string[]; // Padrões de email para reconhecimento (ex: '*nakamura*', '*nelson*naka*')
  
  socialMedia: {
    instagram?: string;
    youtube?: string;
    facebook?: string;
  };
  
  // Biografia e Conquistas
  biography: {
    hometown: string;
    yearsActive: string;
    specialties: string[];
    achievements: string[];
    signatureTechniques: string[];
    famousCatches?: Array<{
      species: string;
      weight: number;
      location: string;
      year: number;
    }>;
  };
  
  // Produtos/Assinaturas
  products?: Array<{
    type: 'bait' | 'rod' | 'reel' | 'line' | 'accessory';
    name: string;
    brand: string;
    description: string;
  }>;
  
  // Conteúdo Personalizado para o Manél
  generatedContent: {
    welcomeMessage: string;
    recognitionPhrases: string[];
  };
  
  popularityScore: number; // 1-100
}

export const FISHING_LEGENDS: FishingLegend[] = [
  {
    id: 'nelson-nakamura',
    type: 'legend',
    status: 'unclaimed',
    
    fullName: 'Nelson Nakamura',
    nicknames: ['Mestre Nakamura', 'Naka', 'Sensei da Pesca'],
    emailPatterns: ['*nakamura*', '*nelson*naka*', '*pesca*naka*', 'nelson@nossapesca.com'], // Adicionado email de teste
    
    socialMedia: {
      instagram: '@nakamurapesca',
      youtube: '@CanalNakamura',
    },
    
    biography: {
      hometown: 'São Paulo, SP',
      yearsActive: '40+ anos',
      specialties: ['Pesca com iscas artificiais', 'Pesca de Bass', 'Técnicas japonesas'],
      achievements: [
        'Pioneiro na introdução de técnicas japonesas no Brasil',
        'Campeão brasileiro de pesca esportiva 5 vezes',
        'Criador da "Isca Nakamura"',
        'Autor de livros sobre pesca e arremesso',
      ],
      signatureTechniques: ['Twitch bait', 'Stop and go', 'Pesca de estrutura'],
      famousCatches: [
        {
          species: 'Tucunaré Açu',
          weight: 12.5,
          location: 'Rio Araguaia',
          year: 1998,
        },
      ],
    },
    
    products: [
      {
        type: 'bait',
        name: 'Isca Nakamura Shad',
        brand: 'Lucky Moldes',
        description: 'Isca de meia água com ação única',
      },
    ],
    
    generatedContent: {
      welcomeMessage: `Olá, Mestre Nakamura! É uma honra indescritível recebê-lo aqui na Nossa Pesca. Suas contribuições para a pesca esportiva brasileira são lendárias! As técnicas que você desenvolveu e ensinou para gerações de pescadores são o alicerce do nosso esporte no Brasil.`,
      
      recognitionPhrases: [
        "O mestre do arremesso de precisão está online!",
        "Quando o Mestre Nakamura fala, todos nós pescadores escutamos.",
        "40 anos ensinando e ainda nos inspirando - bem-vindo, mestre!",
      ],
    },
    
    popularityScore: 98,
  },
  {
    id: 'leo-nakamura',
    type: 'pro',
    status: 'unclaimed',
    
    fullName: 'Leonardo Nakamura',
    nicknames: ['Léo Nakamura', 'Herdeiro da Tradição'],
    emailPatterns: ['*leo*nakamura*', '*lnakamura*'],
    
    socialMedia: {
      instagram: '@leonakamura',
    },
    
    biography: {
      hometown: 'São Paulo, SP',
      yearsActive: '20+ anos',
      specialties: ['Pesca em kayak', 'Pesca de precisão', 'Vídeo produção'],
      achievements: [
        'Campeão do circuito kayak fishing 2022',
        'Referência em conteúdo técnico moderno no YouTube',
        'Desenvolvedor de técnicas de pesca urbana e de caiaque',
      ],
      signatureTechniques: ['Kayak fishing', 'Sight fishing', 'Arremesso técnico'],
    },
    
    generatedContent: {
      welcomeMessage: `Salve, Léo Nakamura! Que satisfação ver você por aqui. O trabalho que você faz elevando o nível técnico da galera no YouTube é fenomenal!`,
      
      recognitionPhrases: [
        "A nova geração técnica está na área!",
        "Léo Nakamura trazendo a precisão da família Nakamura para o portal!",
      ],
    },
    
    popularityScore: 85,
  },
];
